module.exports = __webpack_public_path__ + "static/media/wordmark_white.257b45c3.svg";